import script from "./Error403.vue?vue&type=script&lang=ts&setup=true"
export * from "./Error403.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__